import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvdhnqu62q: FaireProductEntity = {
  token: "p_bvdhnqu62q",
  type: "product",
  name: "Baby Sleep Drops",
  brandToken: "b_b67zcf7gz5",
  brandName: "Pink Stork",
  imageUrl:
    "https://cdn.faire.com/fastly/9f81d9c6810f37df159570e1d9a63fda4eb35b19c87b13da513e49cccc0cd245.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2116f8b89ae057e93afa6e88cdb1dc11157f87de8fc2b9f5df1a91f1417d77a8.jpeg",
    "https://cdn.faire.com/fastly/b957a5d16524f4dc677380eb859e0be44b0af714981e388d11aca4ccc598946d.jpeg",
    "https://cdn.faire.com/fastly/6206451c622f8ad3a36929a124e2dcbeeb483395b570c4a867224c1479a608c3.jpeg",
    "https://cdn.faire.com/fastly/cf4e2fb30db3e02aae0a05047f6edaa92b63c1eb76605bd8d824f2eaf6740676.jpeg",
    "https://cdn.faire.com/fastly/217e3851796755e2517ff39a9246420c49873d664ac8814c232011c7ea713730.jpeg",
  ],
  priceDollars: 10.5,
  description:
    "\nWhat Makes This Special\n\n * \nHealthy sleep leads to happy, healthy babies! Pink Stork has delivered the latest addition to our Pink Stork Baby line - Pink Stork Baby Sleep Drops for children ages four months and up. Simply herbs and vitamins to support restful nights, with no harmful ingredients. Add to your list of baby must haves!\n\n * \nNo melatonin here - our natural liquid baby sleep formula features Vitamin D, Magnesium, Chamomile, Lemon Balm, and Passion Flower to support rested babies and toddlers, relaxation, and immune health. Add to your nightly bedtime routine to help your little one through the night! Administer 1 mL to the side of the inner cheek or add to their food or milk for easy use.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:12.657Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
